var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenderFemale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17.3499C2.25 9.06568 8.96573 2.34995 17.25 2.34995H18.75C27.0343 2.34995 33.75 9.06567 33.75 17.3499V31.15C33.75 33.6352 31.7353 35.6499 29.25 35.6499H6.75C4.26472 35.6499 2.25 33.6352 2.25 31.1499V17.3499Z",
    stroke: "#FF8C69",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31.1499H21C24.3137 31.1499 27 28.4637 27 25.1499V18.0249C27 17.9421 26.9328 17.8749 26.85 17.8749L22.5 17.875C20.0147 17.875 18 15.8603 18 13.375V9.24995C18 9.1671 17.9328 9.09995 17.85 9.09995H13.5C11.0147 9.09995 9 11.1147 9 13.5999V25.1499C9 28.4637 11.6863 31.1499 15 31.1499Z",
    stroke: "#FF8C69",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderFemale);
export default __webpack_public_path__ + "static/media/gender_female.455026fa2c846241fa6fc9df70e1be7a.svg";
export { ForwardRef as ReactComponent };